import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../assets/environments/environment';
import { GlobalConstants } from '../config/GlobalConstants';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) { }


  baseApiUrl = window.location.href.includes(GlobalConstants.extPath) ? environment.baseUrlExt : environment.baseUrlInt;

  // Returns an observable
  download(headers: HttpHeaders, queryParams: HttpParams,responseType: 'json' | 'blob' = 'json'): Observable<any> {
    return this.http.get(this.baseApiUrl +"/content-mgt-process/v1/marketing/file", {
      headers: headers,
      params: queryParams,
      responseType: responseType as 'json'
    }
    )
  }

  getAllFiles(headers: HttpHeaders) {
    return this.http.get(`${this.baseApiUrl}${GlobalConstants.marketingBaseUrl}${GlobalConstants.getAllMediaTypesUrl}`, {
      headers: headers,
    });
  }
}
